/**
 * Defines the domain of the notification.
 */
export var NotificationDomain;
(function (NotificationDomain) {
    /**
     * Notification originated from the Atlas platform.
     */
    NotificationDomain["Atlas"] = "Atlas";
    /**
     * Notification originated from the application itself.
     */
    NotificationDomain["Application"] = "Application";
})(NotificationDomain || (NotificationDomain = {}));
/**
 * Severity levels for notifications.
 */
export var NotificationLevel;
(function (NotificationLevel) {
    NotificationLevel["Debug"] = "Debug";
    NotificationLevel["Info"] = "Info";
    NotificationLevel["Success"] = "Success";
    NotificationLevel["Warning"] = "Warning";
    NotificationLevel["Error"] = "Error";
    NotificationLevel["Fatal"] = "Fatal";
})(NotificationLevel || (NotificationLevel = {}));
/**
 * Types of notification payloads for different display modes.
 */
export var NotificationPayloadType;
(function (NotificationPayloadType) {
    NotificationPayloadType["Banner"] = "Banner";
    NotificationPayloadType["Inbox"] = "Inbox";
    NotificationPayloadType["Toast"] = "Toast";
    NotificationPayloadType["OS"] = "OS";
})(NotificationPayloadType || (NotificationPayloadType = {}));
/**
 * Types of notification actions.
 */
export var NotificationActionType;
(function (NotificationActionType) {
    NotificationActionType["Link"] = "Link";
})(NotificationActionType || (NotificationActionType = {}));
/**
 * Types of image sources.
 */
export var NotificationImageType;
(function (NotificationImageType) {
    /**
     * Image is a reference to a bundled asset or icon name.
     */
    NotificationImageType["Reference"] = "Reference";
    /**
     * Image is a remote URL.
     */
    NotificationImageType["Url"] = "Url";
})(NotificationImageType || (NotificationImageType = {}));
/**
 * Error codes for notification controller operations.
 */
export var NotificationControllerPluginErrorCode;
(function (NotificationControllerPluginErrorCode) {
    /**
     * The notification controller has not been initialized.
     * This occurs when attempting to use the notification controller before it is initialized by the host application.
     */
    NotificationControllerPluginErrorCode["Uninitialized"] = "Uninitialized";
    /**
     * One or more provided arguments are invalid.
     */
    NotificationControllerPluginErrorCode["InvalidArgument"] = "InvalidArgument";
    /**
     * An unexpected runtime error occurred.
     */
    NotificationControllerPluginErrorCode["InternalError"] = "InternalError";
    /**
     * The requested operation is not allowed.
     * This occurs when:
     * - Attempting to change mutable properties (dismissible/deletable) of an Atlas notification.
     * - Attempting to dismiss a notification marked as not dismissible.
     * - Attempting to delete a notification marked as not deletable.
     */
    NotificationControllerPluginErrorCode["NotAllowed"] = "NotAllowed";
})(NotificationControllerPluginErrorCode || (NotificationControllerPluginErrorCode = {}));
//# sourceMappingURL=notification-controller.js.map